<template>
  <v-card flat>
    <v-card-title>
      <v-btn
        :loading="loading"
        class="ma-0 btn-accept"
        depressed
        :disabled="!checkRules"
        @click="addGuide"
      >
        <v-icon left>mdi-content-save-outline</v-icon>
        ثبت
      </v-btn>
    </v-card-title>

    <v-row class="pa-2" no-gutters>
      <v-col class="pa-2" cols="12" md="4">
        <v-text-field
          v-model="data.title"
          class="rounded-lg"
          clearable
          dense
          label="عنوان"
          :rules="[rules.max, rules.required, rules.min]"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="4">
        <v-autocomplete
          v-model="data.service_id"
          :items="services"
          class="rounded-lg"
          dense
          label="انتخاب سرویس"
          :rules="[rules.required_service]"
          outlined
          readonly
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="4">
        <v-autocomplete
          v-model="data.category_id"
          :items="categories"
          class="rounded-lg"
          :loading="categoryLoading"
          dense
          readonly
          label="انتخاب دسته‌بندی"
          :rules="[rules.required_category]"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-textarea
          v-model="data.text"
          class="rounded-lg"
          dense
          label="متن"
          :rules="[rules.required]"
          outlined
          clearable
          clear-icon="mdi-close-circle-outline"
          hint="لطفا توضیحات مورد نظر خود را وارد کنید."
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <v-text-field
          v-model="data.name"
          class="rounded-lg"
          clearable
          dense
          readonly
          :disabled="!!name"
          label="نام یکتا"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <v-text-field
          v-model="data.link"
          append-icon="mdi-link"
          class="rounded-lg"
          clearable
          dense
          label="لینک صدا"
          hint="لطفا لینک صدا مورد نظر خود را وارد کنید."
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-card-title>افزودن تصویر</v-card-title>
        <v-divider class="ma-0" />
        <pic-selector v-model="data.extras.images" :edit-name="false" single />
        <v-divider class="ma-0" />
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-card-title>افزودن ویدئو</v-card-title>
        <v-divider class="ma-0" />
        <video-gallery
          :data="{ video_gallery: data.extras.videos }"
          single-gallery
        />
        <v-divider class="ma-0" />
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-card class="pa-3 rounded-lg" outlined>
          <v-card-title>
            <v-icon class="pa-2" color="green"
              >mdi-comment-question-outline</v-icon
            >
            افزودن سوال متداول
            <v-divider class="ms-2" />
          </v-card-title>

          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel
              v-for="(item, index) in data.extras.qa"
              :key="index"
              :ref="'qa-' + index"
              focusable
            >
              <v-expansion-panel-header>
                <div class="d-flex align-center justify-space-between">
                  <span>{{
                    item.question === "" ? `سوال - ${index + 1}` : item.question
                  }}</span>
                  <v-btn icon small @click.stop="removeQa(index)" class="ms-2">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-col cols="12" class="pa-0">
                  <v-text-field
                    v-model="item.question"
                    class="rounded-lg v-input--dense mb-0 mt-0 pa-0"
                    outlined
                    dense
                    :label="`سوال - ${index + 1}`"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                    hint="لطفا سوال مورد نظر خود را وارد کنید."
                  />
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-textarea
                    v-model="item.answer"
                    class="rounded-lg v-input--dense mb-0 mt-0 pa-0"
                    outlined
                    dense
                    :label="`جواب - ${index + 1}`"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                    hint="لطفا جواب سوال را وارد کنید."
                    placeholder="اگر جوابی برای سوال وارد نکنید سوال شما ذخیره نخواهد شد"
                  />
                </v-col>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-card-actions>
            <v-btn block class="ma-0 btn-accept" depressed @click="addQa">
              <v-icon left>mdi-plus</v-icon>
              افزودن سوال و جواب
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import PicSelector from "@/view/content/pickers/uploadCenter/imageUploader/picSelector.vue";
import VideoGallery from "@/view/content/pickers/uploadCenter/videoUploader/VideoGallery.vue";
import { GetCategories } from "@/view/pages/admin/userGuide/GuideContent_axios.js";

export default {
  name: "addNewUserGuide",
  components: { VideoGallery, PicSelector },
  props: {
    popupContentRef: {
      type: Object,
      default: null,
    },
    info: Object,
    isEdit: { type: Boolean, default: false },
    name: { type: String, default: "" },
    value: Boolean,
    label: { type: String, default: "" },
    serviceName: { type: String, default: "Qrland" },
  },
  data() {
    return {
      catengories_all: [],
      rules: {
        required_service: (value) => !!value || "لطفا یک سرویس انتخاب کنید",
        required_category: (value) => !!value || "لطفا یک دسته انتخاب کنید",
        required: (value) =>
          value?.trim() ? true : "لطفا مقدار این فیلد را وارد کنید",
        urlFormat: (value) => {
          const pattern = new RegExp(
            "^(https?:\\/\\/|www\\.)?" +
              "(localhost|(([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" +
              "(\\d{1,3}(\\.\\d{1,3}){3}))" +
              "(\\:\\d+)?" +
              "(\\/[-a-zA-Z\\d%_.~+]*)*" +
              "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" +
              "(\\#(\\/[-a-zA-Z\\d%_.~+]*)?)?$",
            "i"
          );
          return (
            (!!value?.trim() && pattern.test(value)) ||
            "لطفا لینک معتبر وارد کنید"
          );
        },
        max: (value) =>
          (value && value.length <= 50) ||
          "مقدار این فیلد بیشتر از 50 حرف نباشد! لطفا مقدار فیلد کوتاه‌تری وارد کنید",
        min: (value) =>
          (value && value.length >= 3) ||
          "مقدار این فیلد کمتر از 3 حرف نباشد! لطفا مقدار فیلد بلندتری وارد کنید",
      },
      categoryLoading: false,
      categories: [],
      panel: [], // برای مدیریت پنل‌های باز اکاردیون
      data: {
        service_id: 3,
        title: "",
        text: "",
        category_id: null,
        extras: {
          qa: [{ question: "", answer: "" }], // نمونه خالی اولیه
          images: [{ name: "", images: [] }],
          videos: [{ name: "", images: [] }],
          audio: [],
          others: [],
        },
        link: "",
        name: "",
      },
      services: [],
      loading: false,
    };
  },
  computed: {
    checkRules() {
      return (
        this.rules.max(this.data.title?.trim()) === true &&
        this.rules.min(this.data.title?.trim()) === true &&
        this.rules.required(this.data.text?.trim()) === true &&
        this.rules.required_service(this.data.service_id) === true &&
        this.rules.required_category(this.data.category_id) === true
      );
    },
  },
  mounted() {
    this.getServices();
    // this.getCategories();
    if (this.name) {
      this.data.name = this.name;
    }
    if (this.isEdit && this.info && Object.keys(this.info).length) {
      this.data = JSON.parse(JSON.stringify(this.info));
      if (this.name) {
        this.data.name = this.name;
      }
      // اطمینان از وجود حداقل یک نمونه خالی در حالت ویرایش
      if (!this.data.extras.qa || !this.data.extras.qa.length) {
        this.data.extras.qa = [{ question: "", answer: "" }];
      }
    }
    if (!this.isEdit) {
      this.data.title = this.label;
      this.data.name = this.name;
      this.data.service_id =
        this.services.find((p) => p.text === this.serviceName)?.value || null;
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.value = false;
        this.resetForm();
      }
    },
    services(newVal) {
      this.data.service_id =
        this.services.find((p) => p.text === this.serviceName)?.value || null;
    },
    "data.service_id"(newVal) {
      if (newVal) {
        if (!this.isEdit) this.data.category_id = null;
        this.loadcategories(newVal);
      } else {
        this.categories = [];
        if (!this.isEdit) this.data.category_id = null;
      }
    },
    info: {
      deep: true,
      handler(val) {
        if (this.isEdit && val && Object.keys(val).length) {
          this.data = JSON.parse(JSON.stringify(val));
          if (this.name) {
            this.data.name = this.name;
          }
          // اطمینان از وجود حداقل یک نمونه خالی در حالت ویرایش
          if (!this.data.extras.qa || !this.data.extras.qa.length) {
            this.data.extras.qa = [{ question: "", answer: "" }];
          }
          this.loadcategories(this.data.service_id);
        }
      },
    },
  },
  methods: {
    loadcategories(service_id) {
      if (!service_id) {
        this.categories = [];
        if (!this.isEdit) this.data.category_id = null;
        this.categoryLoading = false;
        return;
      }
      this.categoryLoading = true;
      GetCategories(service_id)
        .then((data) => {
          this.catengories_all = data.map((item) => ({
            value: item.id,
            text: item.name,
            slug: String(item.slug || "")
              .trim()
              .replace(/\/$/, "")
              .toLowerCase(),
          }));
          console.log(this.catengories_all, "category all");
          this.categories = data.map((item) => ({
            value: item.id,
            text: item.name,
          }));
          if (!this.isEdit) {
            const slugPage = this.$route.path
              .slice(1)
              .trim()
              .replace(/\/$/, "")
              .toLowerCase();

            const categoryExists = this.catengories_all.find(
              (cat) => cat.slug === slugPage
            );
            console.log(slugPage, "slugPage");
            console.log(this.catengories_all[33].slug, "slug");
            console.log(
              this.catengories_all[33].slug === slugPage,
              "slug check"
            );

            if (!categoryExists) {
              this.data.category_id = null;
            } else {
              this.data.category_id = categoryExists.value;
            }
          }
          console.log(this.data.category_id, "category id");
          console.log(categoryExists, "category exis");

          if (this.isEdit && this.data.category_id) {
            const categoryExists = this.categories.find(
              (cat) => cat.value === this.data.category_id
            );
            if (!categoryExists) {
              this.data.category_id = null;
            }
          }
        })
        .catch((error) => {
          console.error("خطا در دریافت دسته‌بندی‌ها:", error);
        })
        .finally(() => {
          this.categoryLoading = false;
        });
    },
    resetForm() {
      this.data = {
        service_id: null,
        title: "",
        text: "",
        category_id: null,
        extras: {
          qa: [{ question: "", answer: "" }], // نمونه خالی اولیه
          images: [{ name: "", images: [] }],
          videos: [{ name: "", images: [] }],
          audio: [],
          others: [],
        },
        link: "",
        name: this.name || "",
      };
      this.categories = [];
      this.panel = [];
    },
    getServices() {
      this.requestApiGet("getServices").then(({ data }) => {
        this.services = data.services.map((item) => ({
          value: item.id,
          text: item.nameLand,
        }));
      });
    },

    addGuide() {
      if (this.isEdit) {
        // فیلتر کردن سوال‌هایی که سوال خالی ندارند
        this.data.extras.qa = this.data.extras.qa.filter(
          (item) => !!item.question
        );
        this.$emit("fetch", this.data);
        this.$emit("close");
        this.resetForm();
        return;
      }
      if (!this.data.title || !this.data.name) {
        this.$toast.error("عنوان و نام یکتا اجباری هستند!");
        return;
      }
      this.loading = true;
      let qa = this.data.extras.qa.filter((item) => !!item.question);
      const payload = {
        ...this.data,
        name: this.data.name,
        extras: JSON.stringify({ ...this.data.extras, qa }),
      };
      this.requestApiPost("guideContent/store", payload)
        .then(() => {
          this.$toast.success("با موفقیت ذخیره شد!");
          this.$root.$emit("updateData");
          this.$emit("fetch");
          this.$emit("close");
          this.resetForm();
        })
        .catch((response) => {
          this.$toast.error(
            response?.data?.message || "خطا در افزودن راهنمای جدید!"
          );
          console.error("failed to store new user guide:", response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addQa() {
      this.data.extras.qa.push({ question: "", answer: "" });
      const newIndex = this.data.extras.qa.length - 1;
      this.panel.push(newIndex);
      this.$nextTick(() => {
        setTimeout(() => {
          const lastItemRef = this.$refs[`qa-${newIndex}`];
          if (lastItemRef && lastItemRef[0]) {
            lastItemRef[0].$el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
          if (this.popupContentRef) {
            this.popupContentRef.scrollTop = this.popupContentRef.scrollHeight;
          }
        }, 300);
      });
      this.$forceUpdate();
    },
    removeQa(index) {
      this.data.extras.qa.splice(index, 1);
      this.panel = this.panel.filter((i) => i !== index);
      if (!this.data.extras.qa.length) {
        this.data.extras.qa = [{ question: "", answer: "" }];
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped>
.v-expansion-panel-content .v-text-field,
.v-expansion-panel-content .v-textarea {
  margin-bottom: 4px !important;
}

@media (max-width: 780px) {
  .v-btn {
    margin-top: 10px !important;
    padding-top: 10px !important;
  }
  .v-text-field,
  .v-textarea {
    width: 100% !important;
    flex: 1 1 100%;
    margin-bottom: 10px !important;
  }
}
</style>
